import { useMemo, useRef } from 'react';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import NoLessonPaper from '../../../paper/NoLessonPaper';
import LessonCard, { CARD_VARIANT_ACTIVITY } from '../../../card/LessonCard';
import LessonDetail from './LessonDetail';
import ViewLessonDetailAction from './actions/ViewLessonDetailAction';
import CardDetailContainer, { useCardDetail } from '../CardDetailContainer';
import './FlatLessonCardListDetail.scss';
import { calculateCardSize } from '../../../../utils/CardSizeCalculator';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  cardSize: calculateCardSize(),
  lessonData: {},
  noLessonMessage: 'No Activities Available',
  createCardAction: () => ([]),
  createCardDetailAction: () => ([]),
  currentUser: {},
  currentUserProfle: {},
  onLessonSelect: () => { },
  selectedLessonIds: [],
  createLessonDetailAction: () => ([]),
  showLessonBadges: undefined,
  cardVariant: undefined,
};

const FlatLessonCardListDetail = (props) => {
  const {
    cardSize,
    lessonData,
    noLessonMessage,
    createCardAction,
    createCardDetailAction,
    currentUser,
    currentUserProfle,
    onLessonSelect,
    selectedLessonIds,
    createLessonDetailAction,
    showLessonBadges,
    cardVariant,
  } = { ...defaultProps, ...filterUndefined(props) };
  const {
    handleOnViewDetailClick,
    handleOnCloseDetail,
    openCardDetail,
  } = useCardDetail();

  const lessonList = useMemo(() => (
    <div className={`list-detail-container${cardVariant === CARD_VARIANT_ACTIVITY ? ' activity-card-list' : ''}`}>
      {
        lessonData.lessons.length > 0 ? (
          lessonData.lessons.map((lesson, cardIndex) => {
            const actions = createCardAction(lesson, cardIndex) || [];
            const key = `vizzle-lesson-detail-lesson-index-${cardIndex}`;
            actions.push(
              <ViewLessonDetailAction
                key={key}
                className={key}
                onClick={() => { handleOnViewDetailClick(cardIndex, 0); }}
              />,
            );
            return (
              <Box
                key={`lessons-action-id-${lesson.attributes.uuid}`}
                className='lesson-card-action'
                onClick={() => onLessonSelect(lesson)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onLessonSelect(lesson);
                  }
                }}
              >
                <LessonCard
                  key={`lessons-id-${lesson.attributes.uuid}`}
                  lessonData={lesson}
                  width={cardSize.width}
                  actions={actions}
                  isHighligthed={selectedLessonIds.includes(lesson.id)}
                  showLessonBadges={showLessonBadges}
                  cardVariant={cardVariant}
                />
              </Box>
            );
          })
        ) : <NoLessonPaper message={noLessonMessage} />
      }
    </div>
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [lessonData.lessons, selectedLessonIds]);

  const cardSlide = useRef(null);

  const lessonDetail = () => (
    openCardDetail.open ? (
      <CardDetailContainer
        ref={cardSlide}
        open={openCardDetail.open}
        selectedIndex={openCardDetail.selectedIndex}
        onClose={handleOnCloseDetail}
        dataList={lessonData.lessons}
        createCardFunction={(lesson, index) => (
          <LessonDetail
            inert={openCardDetail.selectedIndex !== index}
            key={`lesson-detail-${lesson.id}`}
            lesson={lesson}
            currentUser={currentUser}
            currentUserProfle={currentUserProfle}
            included={lessonData.included}
            actions={createCardDetailAction(
              lesson,
              currentUser,
              0,
              () => {
                handleOnCloseDetail();
              },
            )}
            lessonDetailActions={createLessonDetailAction(lesson)}
          />
        )}
      />
    ) : null
  );

  return (
    <Fade in>
      <div className='flat-lesson-card-list-detail'>
        {lessonList}
        {lessonDetail()}
      </div>
    </Fade>
  );
};

export default FlatLessonCardListDetail;
